import { render, staticRenderFns } from "./kpsrScenario.vue?vue&type=template&id=3dba855a"
import script from "./kpsrScenario.vue?vue&type=script&lang=js"
export * from "./kpsrScenario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dba855a')) {
      api.createRecord('3dba855a', component.options)
    } else {
      api.reload('3dba855a', component.options)
    }
    module.hot.accept("./kpsrScenario.vue?vue&type=template&id=3dba855a", function () {
      api.rerender('3dba855a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/ram/kpsr/kpsrScenario.vue"
export default component.exports